{
  "title": "Повідомлення",

  "contactForm": {
    "radio-group": {
      "title": "Тема",
      "items": [
        "Діагностика",
        "Профіль / Авторизація",
        "Технічна проблема",
        "Пропозиція покращення",
        "Співробітництво",
        "Медіа / PR",
        "Інше"
      ]
    },

    "validationErrors": {
      "subject": "Будь ласка, оберіть тему повідомлення",
      "email": "Некоректний формат email ",
      "message": "Повідомлення має містити від 1 до 1000 символів."
    },

    "generalErrorMessages": {
      "failed-to-send": "Невдалося надіслати лист. Спробуйте пізніше."
    },

    "formFields": {
      "email": {
        "label": "Email",
        "placeholder": "mail@sample.com"
      },
      "message": {
        "label": "Ваше повідомлення",
        "placeholder": "Напишіть текст"
      }
    },

    "button": {
      "sent": "Відправлено",
      "loading": "Відправляємо...",
      "send": "Відправити",
      "close": "Відмінити"
    }
  }
}
